import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Section from '../../../components/Section';

import styles from './Payment.module.css';

export const Payment: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (import.meta.env.SSR) {
      return;
    }
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE') {
        navigate(event.data.path);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  if (import.meta.env.SSR) {
    return null;
  }

  return (
    <div className={styles.faq}>
      <Section>
        <iframe
          src={`https://jam-customer-care-hub.lovable.app/payment?homePageUrl=${window.location.origin}`}
          className={styles.iframe}
          title="Payment"
        />
      </Section>
    </div>
  );
};
